export const Link = "https://narbapis.rosoftsavvy.app";
